var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9664 10.8694L21.7971 18.1816L19.6426 14.9023L30.8119 7.59014L32.9664 10.8694Z",
    fill: "#5649B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6762 26.5549L30.8455 33.8671L33 30.5879L21.8307 23.2757L19.6762 26.5549Z",
    fill: "#5649B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7857 29.2189C16.2352 29.2189 19.8422 25.6183 19.8422 21.1768C19.8422 16.7352 16.2352 13.1347 11.7857 13.1347C7.33623 13.1347 3.7292 16.7352 3.7292 21.1768C3.7292 25.6183 7.33623 29.2189 11.7857 29.2189ZM11.7857 32.9415C18.2948 32.9415 23.5714 27.6742 23.5714 21.1768C23.5714 14.6793 18.2948 9.41211 11.7857 9.41211C5.27664 9.41211 0 14.6793 0 21.1768C0 27.6742 5.27664 32.9415 11.7857 32.9415Z",
    fill: "#5649B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22115 17.3164C8.65329 17.5523 8.64258 17.6488 8.64258 21.1985V24.4908L8.89972 24.7911C9.38186 25.3487 9.68186 25.2522 12.5533 23.6007C13.9676 22.7964 15.2533 21.9814 15.4247 21.8098C15.6069 21.6167 15.714 21.3808 15.714 21.177C15.714 20.9733 15.6069 20.7374 15.4247 20.5443C15.0604 20.1583 10.164 17.3378 9.74615 17.2628C9.58544 17.2413 9.33901 17.2628 9.22115 17.3164Z",
    fill: "#5649B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9289 10.6432C38.912 10.6432 40.5197 9.03843 40.5197 7.05881C40.5197 5.07918 38.912 3.47438 36.9289 3.47438C34.9457 3.47438 33.338 5.07918 33.338 7.05881C33.338 9.03843 34.9457 10.6432 36.9289 10.6432ZM36.9289 14.1176C40.8343 14.1176 44.0003 10.9573 44.0003 7.05881C44.0003 3.16034 40.8343 0 36.9289 0C33.0234 0 29.8574 3.16034 29.8574 7.05881C29.8574 10.9573 33.0234 14.1176 36.9289 14.1176Z",
    fill: "#5649B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9289 36.5251C38.912 36.5251 40.5197 34.9203 40.5197 32.9406C40.5197 30.961 38.912 29.3562 36.9289 29.3562C34.9457 29.3562 33.338 30.961 33.338 32.9406C33.338 34.9203 34.9457 36.5251 36.9289 36.5251ZM36.9289 39.9994C40.8343 39.9994 44.0003 36.8391 44.0003 32.9406C44.0003 29.0422 40.8343 25.8818 36.9289 25.8818C33.0234 25.8818 29.8574 29.0422 29.8574 32.9406C29.8574 36.8391 33.0234 39.9994 36.9289 39.9994Z",
    fill: "#5649B7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a95e7dd195241c823f5b9a811463a05d.svg";
export { ForwardRef as ReactComponent };